import { render } from "./DataStep.vue?vue&type=template&id=4558cdf3&scoped=true"
import script from "./DataStep.vue?vue&type=script&lang=js"
export * from "./DataStep.vue?vue&type=script&lang=js"

import "./DataStep.vue?vue&type=style&index=0&id=4558cdf3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4558cdf3"

export default script